import endpoints from 'helper/endpoints'
import {fireSuccessToast, globalApiErrorHandler} from 'helper/functions'
import httpClient from 'helper/httpClient'
import React from 'react'
import {
  GET_PRED_TERM_FAIL,
  GET_PRED_TERM_LIST_FAIL,
  GET_PRED_TERM_LIST_REQUEST,
  GET_PRED_TERM_LIST_SUCCESS,
  GET_PRED_TERM_REQUEST,
  GET_PRED_TERM_SUCCESS,
} from 'redux/actionType'
import {Trans} from '@lingui/macro'

export const getPredefinedTermList = (limit = 1000, offset = 0, meta, search) => {
  return (dispatch) => {
    dispatch({type: GET_PRED_TERM_LIST_REQUEST})
    const searchQuery = search ? `?search=${search}` : ''
    return httpClient
      .get(endpoints.predefinedTerms + searchQuery, {
        limit: limit,
        offset: offset,
        order_by:
          meta?.orderBy && meta?.orderDirection && `${meta?.orderBy}:${meta?.orderDirection}`,
      })
      .then((res) => {
        dispatch({type: GET_PRED_TERM_LIST_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_PRED_TERM_LIST_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const getPredefinedTerm = (id) => {
  return (dispatch) => {
    dispatch({type: GET_PRED_TERM_REQUEST})
    return httpClient
      .get(endpoints.predefinedTerms + '/' + id)
      .then((res) => {
        dispatch({type: GET_PRED_TERM_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_PRED_TERM_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const createPredefinedTerm = (data) => {
  return (dispatch) => {
    return httpClient
      .post(endpoints.predefinedTerms, data)
      .then((res) => {
        fireSuccessToast(<Trans>New predefined term created.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}

export const patchPredefinedTerm = (id, data) => {
  return (dispatch) => {
    return httpClient
      .patch(endpoints.predefinedTerms + '/' + id, data)
      .then((res) => {
        fireSuccessToast(<Trans>Predefined term updated.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}
